// Import all images so webpack processes them
const images = require.context('../assets/images', false, /\.(png|jpe?g|gif|svg)$/);
images.keys().forEach(images);
